import { render, staticRenderFns } from "./singleuser.vue?vue&type=template&id=27fab9ee&"
import script from "./singleuser.vue?vue&type=script&lang=js&"
export * from "./singleuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports